const API = '/api';

export async function fetchPersons() {
  return request('/persons');
}

export async function fetchPerson(id) {
  return request(`/persons/${id}`);
}

export async function fetchPersonResearch(id) {
  return request(`/persons/${id}/research`);
}

export async function syncResearchTasks(personId) {
  return request(`/persons/${personId}/research/tasks/sync`, { method: 'POST' });
}

export async function updateResearchTask(personId, taskId, action) {
  return request(`/persons/${personId}/research/tasks/${taskId}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ action }),
  });
}

export async function createPerson(data) {
  return request('/persons', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });
}

export async function updatePerson(id, data) {
  return request(`/persons/${id}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });
}

export async function deletePerson(id) {
  return request(`/persons/${id}`, { method: 'DELETE' });
}

export async function searchPerson(id) {
  return request(`/persons/${id}/search`, { method: 'POST' });
}

export async function fetchReviewItems(filters = {}) {
  const params = new URLSearchParams();
  for (const [key, value] of Object.entries(filters)) {
    if (value) params.set(key, value);
  }
  const query = params.toString();
  return request(`/review${query ? `?${query}` : ''}`);
}

export async function updateSearchResult(personId, resultId, action) {
  return request(`/persons/${personId}/results/${resultId}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ action }),
  });
}

export async function confirmSearchResult(personId, resultId) {
  return updateSearchResult(personId, resultId, 'confirm');
}

export async function rejectSearchResult(personId, resultId) {
  return updateSearchResult(personId, resultId, 'reject');
}

export async function reopenSearchResult(personId, resultId) {
  return updateSearchResult(personId, resultId, 'reopen');
}

export async function fetchStats() {
  return request('/stats');
}

export async function login(password) {
  return request('/auth/login', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ password }),
  });
}

export async function logout() {
  return request('/auth/logout', { method: 'POST' });
}

async function request(path, options) {
  const res = await fetch(`${API}${path}`, options);
  const contentType = res.headers.get('content-type') || '';
  const payload = contentType.includes('application/json')
    ? await res.json().catch(() => null)
    : await res.text().catch(() => '');

  if (!res.ok) {
    const message = payload?.error || payload || `Request fehlgeschlagen (${res.status})`;
    if (res.status === 401 && typeof window !== 'undefined' && window.location.pathname !== '/login') {
      const next = `${window.location.pathname}${window.location.search}`;
      window.location.assign(`/login?next=${encodeURIComponent(next)}`);
    }
    throw new Error(message);
  }

  return payload;
}
